import styled from 'styled-components';

export const Container = styled.div<{small?: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({small}) => small ? '100%': '100vw' };
  height: ${({small}) => small ? '100%': '100vh' };
`;
